// libs
import React, { useEffect } from 'react';

import useToggle from '@lyearn/core/hooks/useToggle';
import { useTranslation } from '@lyearn/i18n';
import { getSelectedOperatorTillBESupport } from '@/components/FilterManager/SortAndFilter/components/SortAndFilter';
import { FilterState } from '@/components/FilterManager/types';
import { FilterBodyConfig } from '@/components/FilterNew/types';
import BaseEntityFilter from '@/components/Filters/EntityFilter/BaseEntityFilter';

type EntityPillProps = {
  configToRenderFilterBody?: FilterBodyConfig<{}>;
  filter: FilterState;
  setFilter: (filter: any) => void;
  id: string;
  filterIdToOpen?: string;
  setFilterIdToOpen: (id: string) => void;
};

export const isEntityPillSelected = (filter: FilterState, id: string) => {
  const selectedItems = filter[id];

  return (
    Array.isArray(selectedItems) &&
    selectedItems.length !== 0 &&
    typeof selectedItems[0] === 'string'
  );
};

const EntityPill = ({
  id,
  filter,
  setFilter,
  configToRenderFilterBody,
  setFilterIdToOpen,
  filterIdToOpen,
}: EntityPillProps) => {
  const { t } = useTranslation();
  const [isOpen, { toggle, on, off }] = useToggle(false);

  useEffect(() => {
    if (filterIdToOpen === id) {
      on();
    } else {
      off();
    }
  });
  if (!configToRenderFilterBody) return null;

  const {
    listConfig: { useFilterValues },
    headerProps: { label },
  } = configToRenderFilterBody;

  if (!useFilterValues || !isEntityPillSelected(filter, id)) {
    return null;
  }

  return (
    <BaseEntityFilter
      defaultPlaceholder={label}
      filter={filter}
      id={id}
      initialSelectedOperator={getSelectedOperatorTillBESupport(t)}
      listConfig={configToRenderFilterBody.listConfig}
      open={isOpen}
      pillProps={{
        onRemove: () => {
          setFilter({
            ...filter,
            [id]: [],
          });
        },
      }}
      setFilter={setFilter}
      uiConfig={configToRenderFilterBody.uiConfig}
      onToggle={() => {
        toggle();
        setFilterIdToOpen(isOpen ? '' : id);
      }}
    />
  );
};

export default EntityPill;
